import React from "react";
import { Button, Tooltip, Typography } from "@mui/joy";

interface TranscriptFolderNameButtonProps {
  current: boolean;
  name: string;
  onClick: () => void;
}

const TranscriptFolderNameButton: React.FC<TranscriptFolderNameButtonProps> = ({
  current,
  name,
  onClick,
}) => (
  <Tooltip title={name} placement="top" enterDelay={0}>
    <Button
      variant="plain"
      color="neutral"
      size="sm"
      aria-current={current ? "page" : undefined}
      title={name}
      onClick={onClick}
      style={{ flex: "1 1 auto", minWidth: 64 }}
      sx={{ justifyContent: "flex-start", alignItems: "flex-start", px: 0.5 }}
    >
      <Typography
        level="body-sm"
        sx={{
          flex: 1,
          minWidth: 0,
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          textAlign: "left",
        }}
      >
        {name}
      </Typography>
    </Button>
  </Tooltip>
);

export default TranscriptFolderNameButton;
